export default __webpack_public_path__ + "static/media/pantry1-afterF-768w.844915c3.png";